import PropTypes from 'prop-types'

/*
EXAMPLE:
{
 id: "11ea9de623bb1d308595b9f3f6520c3f"
 level: 4
 updated_at: 1590342235
}
*/

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  updated_at: PropTypes.number,
})
